import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Mirrors the prototype's scroll-to-top on every view change.
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, behavior: 'auto' });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};
